import {
  Autocomplete,
  Card,
  CardContent,
  FormControl,
  Grid,
  Stack,
  TextField,
  Typography,
  Button
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/breadcrumb";
import { AppLayout } from "../../../layouts/app";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Box from "@mui/material/Box";
import MakePDF from "./pdfs/index";
import MakeFarmsPDF from "./pdfs/index2";
import { ExportExcel, ExportExcelFarm } from "./sheets";
import styles from "./Reports.module.scss";
import { ReportService } from "../../../services/report";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { LineChartReport } from "../../../components/sensorChartReport";
import { Switch, FormGroup, FormControlLabel } from "@mui/material";
import { LineChartCardReport } from "../../../components/farmCard/sensorChartCard/index2";
import { TrackerRelationshipsService } from "../../../services/trackerRelationships";
import { FilePdfTwoTone, FileExcelTwoTone } from "@ant-design/icons";
import { CustomSkeleton } from "../../../components/skeleton";

export const ReportsAdmin = () => {
  const date = new Date();
  const [breadcrumbs, setBreadcrumbs] = useContext(BreadcrumbContext);
  const [vehicles, setVehicles] = useState([]);
  const [farms, setFarms] = useState([]);
  const [vehicleSelected, setVehicleSelected] = useState("");
  const [initialDate, setInitialDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [finalDate, setFinalDate] = useState(new Date(Date.now()));
  const [loadingReports, setLoadingReports] = useState(false);
  const [loadingReportsSkeleton, setLoadingReportsSkeleton] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [alarms, setAlarms] = useState([]);
  const [sensorsData, setSensorsData] = useState([]);
  const [inputValueSwitch, setInputValueSwitch] = useState("vehicles");
  const [inputValueLabel, setInputValueLabel] = useState("Veículos");
  const [powerTensionNominal, setPowerTensionNominal] = useState("");
  const [companyName, setCompanyName] = useState("");
  const reportService = new ReportService();
  const trackerRelationshipService = new TrackerRelationshipsService();

  const columns = [
    {
      field: "sensorName",
      headerName: "Sensor",
      width: 230,
      editable: false,
      renderCell: (sensorName) => {
        var ptName = sensorName.value;
        if (sensorName.value === "Humidity 1") ptName = "Umidade 1";
        else if (sensorName.value === "Humidity 2") ptName = "Umidade 2";
        else if (sensorName.value === "Internal Temperature 1")
          ptName = "Temperatura 1";
        else if (sensorName.value === "Internal Temperature 2")
          ptName = "Temperatura 2";
        else if (sensorName.value === "Vibration 1") ptName = "Vibração 1";
        else if (sensorName.value === "Vibration 2") ptName = "Vibração 2";
        return ptName;
      },
    },
    {
      field: "sensorValue",
      headerName: "Valor",
      width: 150,
      editable: false,
    },
    {
      field: "sensorMinThreshold",
      headerName: "Limiar Inferior",
      width: 125,
      editable: false,
    },
    {
      field: "sensorMaxThreshold",
      headerName: "Limiar Superior",
      width: 125,
      editable: false,
    },
    {
      field: "dtEvent",
      headerName: "Data",
      type: "dateTime",
      width: 180,
      editable: false,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YY HH:mm:ss"),
    },
    {
      field: "latitude",
      headerName: "Latitude",
      width: 150,
      editable: false,
    },
    {
      field: "longitude",
      headerName: "Longitude",
      type: "dateTime",
      width: 150,
      editable: false,
    },
  ];

  useEffect(() => {
    const breadcrumbsState = [
      <Link key="1" to="/">
        Home
      </Link>,
      <Typography key="2" color="text.primary">
        Relatórios
      </Typography>,
    ];
    var result = sessionStorage.getItem("valueKanban");
    if (result !== null) {
      setInputValueLabel(sessionStorage.getItem("valueKanbanLabel"));
      setInputValueSwitch(result);
    }
    getVehicles();

    setBreadcrumbs(breadcrumbsState);
  }, []);

  const transformVehiclesIntoOptions = (vehicles) => {
    let plates = [];
    let farms = [];
    vehicles.forEach((v) => {
      if (v.typeOperation === "OVOS" || v.typeOperation === "PINTOS" || v.typeOperation === "EMBRIÕES") {
        plates.push({ label: v.vehiclePlate });
      } else if (
        v.typeOperation === "SALA1" ||
        v.typeOperation === "SALA2" ||
        v.typeOperation === "SALA3" ||
        v.typeOperation === "SALA4"
      ) {
        farms.push({ label: v.vehiclePlate });
      }
    });


    setVehicles(plates);
    setFarms(farms);
  };

  const getVehicles = () => {
    trackerRelationshipService
      .getReportView()
      .then((res) => {
        transformVehiclesIntoOptions(res.data);
      })
      .catch((err) => {
      });
  };

  const calculateDifferenceInDays = (date1, date2) => {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffInMilliseconds = Math.abs(date1 - date2);
    return Math.round(diffInMilliseconds / oneDay);
  };

  const handleReportsGenerate = () => {
    if (finalDate > initialDate) {
      if (vehicleSelected && initialDate && finalDate) {
        var result = calculateDifferenceInDays(finalDate, initialDate);
        if (result <= 10) {
          setLoadingReports(true);
          setLoadingReportsSkeleton(true);
          reportService
            .getReportInfo(
              vehicleSelected,
              initialDate.toLocaleString(),
              finalDate.toLocaleString()
            )
            .then((res) => {
              if (res.status === 204) {
                setLoadingReportsSkeleton(false);
                setReportData(null);
                setSensorsData(null);
                NotificationManager.warning(
                  "Sem dados para gerar relatório com os filtros selecionados.", "", 3000
                );
              } else {
                setReportData(res.data);
                setSensorsData(res.data.sensorsData);
                setAlarms(res.data.alarms);
                setPowerTensionNominal(res.data.powerTension_Nominal);
                setLoadingReports(false);
                setLoadingReportsSkeleton(false);
                setCompanyName(res.data.nameOfCompany);
              }
            })
            .catch((err) => {
              NotificationManager.error("Erro ao carregar informações", "", 3000);
              setLoadingReportsSkeleton(false);
              setReportData(null);
              setSensorsData(null);
            });
        } else {
          NotificationManager.warning("Período maior que dez dias.", "", 3000);
          setLoadingReportsSkeleton(false);
          setReportData(null);
          setSensorsData(null);
        }
      } else {
        NotificationManager.warning(
          "Preencha todos os filtros para gerar o relatório.", "", 3000
        );
        setLoadingReportsSkeleton(false);
        setReportData(null);
        setSensorsData(null);
      }
    } else {
      NotificationManager.warning("Data inicial maior que data final.", "", 3000);
      setLoadingReportsSkeleton(false);
      setReportData(null);
      setSensorsData(null);
    }
  };

  const handleChangeInitialDate = (date) => {
    setInitialDate(date);
    setTimeout(() => {
      setLoadingReports(true);
    }, 100);
  };

  const handleChangeFinalDate = (date) => {
    setFinalDate(date);
    setTimeout(() => {
      setLoadingReports(true);
    }, 100);
  };

  const getSensorDataTemp = (sensorData) => {
    let labels = [];
    let lat = [];
    let lng = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor4Data = [];
    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor4Values = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThresholdValues = [];

    sensor1Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 1"
    );
    sensor2Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 2"
    );
    sensor3Data = sensorData.filter(
      (i) => i.sensorName === "External Temperature"
    );
    sensor4Data = sensorData.filter(
      (i) => i.sensorName === "Average Temperature"
    );

    for (let i = 0; i < sensor1Data.length; i++) {
      sensor1Values.push(
        parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
      );
      lat.push(sensor1Data[i].latitude);
      lng.push(sensor1Data[i].longitude);
      sensorMaxThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
      );
      sensorMinThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
      );
      labels.push(sensor1Data[i].dtEvent);
    }

    for (let i = 0; i < sensor2Data.length; i++) {
      sensor2Values.push(
        parseFloat(sensor2Data[i].sensorValue.replace(",", "."))
      );
    }

    for (let i = 0; i < sensor3Data.length; i++) {
      sensor3Values.push(
        parseFloat(sensor3Data[i].sensorValue.replace(",", "."))
      );
    }

    for (let i = 0; i < sensor4Data.length; i++) {
      sensor4Values.push(
        parseFloat(sensor4Data[i].sensorValue.replace(",", "."))
      );
    }

    var dataToChart = {
      lat: lat,
      lng: lng,
      labels: labels,
      sensor1Values: sensor1Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensor4Values: sensor4Values,
      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
    };

    return dataToChart;
  };

  const getSensorData = (sensorData, sensor) => {
    let labels = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor4Data = [];
    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor4Values = [];
    let sensor5Values = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThresholdValues = [];

    if (sensor === "humidity") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Humidity 1");
      sensor2Data = sensorData.filter((i) => i.sensorName === "Humidity 2");
      sensor3Data = sensorData.filter(
        (i) => i.sensorName === "Average Humidity"
      );
    } else if (sensor === "co2") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "CO2");
    } else if (sensor === "vibration") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Vibration");
    } else if (sensor === "ThermoKing") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "ThermoKing");
      sensor2Data = sensorData.filter((i) => i.sensorName === "Port");
      sensor3Data = sensorData.filter((i) => i.sensorName === "Ignition");
      sensor4Data = sensorData.filter((i) => i.sensorName === "Speed");
    } else if (sensor === "PowerTension") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "PowerTension");
      sensor2Data = sensorData.filter((i) => i.sensorName === "Ignition");
    } else if (sensor === "Odometer") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Odometer");
    }

    if (sensor !== "ThermoKing") {
      if (sensor === "humidity") {
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
          );
          sensorMaxThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
          );
          sensorMinThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
          );
          labels.push(sensor1Data[i].dtEvent);
        }

        for (let i = 0; i < sensor2Data.length; i++) {
          sensor2Values.push(
            parseFloat(sensor2Data[i].sensorValue.replace(",", "."))
          );
        }

        for (let i = 0; i < sensor3Data.length; i++) {
          sensor3Values.push(
            parseFloat(sensor3Data[i].sensorValue.replace(",", "."))
          );
        }
      } else if (sensor === "co2" || sensor === "vibration") {
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
          );
          sensorMaxThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
          );
          sensorMinThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
          );
          labels.push(moment(sensor1Data[i].dtEvent).format());
        }
      } else if (sensor === "PowerTension") {
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            sensor1Data[i].sensorValue.replace(",", ".")
          );
          labels.push(sensor1Data[i].dtEvent);
        }
        for (let i = 0; i < sensor2Data.length; i++) {
          sensor2Values.push(
            sensor2Data[i].sensorValue.startsWith("1") && powerTensionNominal === "12" ? 24 : sensor2Data[i].sensorValue.startsWith("1") && powerTensionNominal === "24" ? 39 : NaN
          );
        }
      } else if (sensor === "Odometer") {
        sensor1Data.shift();
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            sensor1Data[i].sensorValue.replace(",", ".")
          );
        }
      }
    } else {

      for (let i = 0; i < sensor1Data.length; i++) {
        sensor1Values.push(
          sensor1Data[i].sensorValue.replace("ON", parseInt(180))
        );
        labels.push(sensor1Data[i].dtEvent);
      }

      for (let i = 0; i < sensor2Data.length; i++) {
        sensor2Values.push(
          sensor2Data[i].sensorValue.replace("True", parseInt(140))
        );
      }

      for (let i = 0; i < sensor3Data.length; i++) {
        sensor4Values.push(
          sensor3Data[i].sensorValue.startsWith("1") ? 160 : NaN
        );
      }

      for (let i = 0; i < sensor4Data.length; i++) {
        sensor5Values.push(parseFloat(sensor4Data[i].sensorValue));
      }
    }

    var dataToChart = {
      labels: labels,
      sensor1Values: sensor1Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensor4Values: sensor4Values,
      sensor5Values: sensor5Values,
      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
    };
    return dataToChart;
  };

  const getSensorDataTempFarm = (sensorData) => {
    let labels = [];
    let lat = [];
    let lng = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor4Data = [];
    let sensor1Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor4Values = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThresholdValues = [];

    sensor1Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 1"
    );
    sensor2Data = sensorData.filter(
      (i) => i.sensorName === "Internal Temperature 2"
    );
    sensor3Data = sensorData.filter(
      (i) => i.sensorName === "External Temperature"
    );
    sensor4Data = sensorData.filter(
      (i) => i.sensorName === "Average Temperature"
    );

    for (let i = 0; i < sensor1Data.length; i++) {
      sensor1Values.push(
        parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
      );
      lat.push(sensor1Data[i].latitude);
      lng.push(sensor1Data[i].longitude);
      sensorMaxThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
      );
      sensorMinThresholdValues.push(
        parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
      );
      labels.push(sensor1Data[i].dtEvent);
    }

    for (let i = 0; i < sensor2Data.length; i++) {
      sensor2Values.push(
        parseFloat(sensor2Data[i].sensorValue.replace(",", "."))
      );
    }

    for (let i = 0; i < sensor3Data.length; i++) {
      sensor3Values.push(
        parseFloat(sensor3Data[i].sensorValue.replace(",", "."))
      );
    }

    for (let i = 0; i < sensor4Data.length; i++) {
      sensor4Values.push(
        parseFloat(sensor4Data[i].sensorValue.replace(",", "."))
      );
    }

    var dataToChart = {
      lat: lat,
      lng: lng,
      labels: labels,
      sensor1Values: sensor1Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensor4Values: sensor4Values,

      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
    };

    return dataToChart;
  };

  const getSensorDataFarm = (sensorData, sensor) => {
    let labels = [];
    let sensor1Data = [];
    let sensor2Data = [];
    let sensor3Data = [];
    let sensor1Values = [];
    let sensor12Values = [];
    let sensor11Values = [];
    let sensor2Values = [];
    let sensor3Values = [];
    let sensor32Values = [];
    let sensor31Values = [];
    let sensor4Values = [];
    let sensorMaxThresholdValues = [];
    let sensorMinThresholdValues = [];

    if (sensor === "humidity") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "Humidity 1");
      sensor2Data = sensorData.filter((i) => i.sensorName === "Humidity 2");
      sensor3Data = sensorData.filter(
        (i) => i.sensorName === "Average Humidity"
      );
    } else if (sensor === "co2") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "CO2");
    } else if (sensor === "portAndAc") {
      sensor1Data = sensorData.filter((i) => i.sensorName === "ThermoKing");
      sensor3Data = sensorData.filter((i) => i.sensorName === "Port");
    }

    if (sensor !== "portAndAc") {
      if (sensor === "humidity") {
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
          );
          sensorMaxThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
          );
          sensorMinThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
          );
          labels.push(sensor1Data[i].dtEvent);
        }

        for (let i = 0; i < sensor2Data.length; i++) {
          sensor2Values.push(
            parseFloat(sensor2Data[i].sensorValue.replace(",", "."))
          );
        }

        for (let i = 0; i < sensor3Data.length; i++) {
          sensor3Values.push(
            parseFloat(sensor3Data[i].sensorValue.replace(",", "."))
          );
        }
      } else if (sensor === "co2") {
        for (let i = 0; i < sensor1Data.length; i++) {
          sensor1Values.push(
            parseFloat(sensor1Data[i].sensorValue.replace(",", "."))
          );
          sensorMaxThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMaxThreshold.replace(",", "."))
          );
          sensorMinThresholdValues.push(
            parseFloat(sensor1Data[i].sensorMinThreshold.replace(",", "."))
          );
          labels.push(sensor1Data[i].dtEvent);
        }
      }
    } else {
      for (let i = 0; i < sensor1Data.length; i++) {
        sensor1Values.push(
          sensor1Data[i].sensorValue.replace("ON", parseInt(0))
        );
        sensor11Values.push(
          sensor1Data[i].sensorValue === "OFF"
            ? sensor1Data[i].sensorValue.replace("OFF", parseInt(0))
            : "OFF_ATTENTION"
        );
        sensor12Values.push(
          sensor1Data[i].sensorValue === "OFF"
            ? sensor1Data[i].sensorValue.replace("OFF", parseInt(0))
            : "OFF_ATTENTION"
        );
        labels.push(sensor1Data[i].dtEvent);
      }

      for (let i = 0; i < sensor3Data.length; i++) {
        sensor3Values.push(
          sensor3Data[i].sensorValue.replace("True", parseInt(1))
        );
        sensor31Values.push(
          sensor3Data[i].sensorValue.replace("False", parseInt(1))
        );
        sensor32Values.push(
          sensor3Data[i].sensorValue.replace("False", parseInt(1))
        );
      }
    }

    var dataToChart = {
      labels: labels,
      sensor1Values: sensor1Values,
      sensor11Values: sensor11Values,
      sensor12Values: sensor12Values,
      sensor2Values: sensor2Values,
      sensor3Values: sensor3Values,
      sensor31Values: sensor31Values,
      sensor32Values: sensor32Values,
      sensor4Values: sensor4Values,
      sensorMinThresholdValues: sensorMinThresholdValues,
      sensorMaxThresholdValues: sensorMaxThresholdValues,
    };
    return dataToChart;
  };

  const handleChangeSwitch = (evt, value) => {
    if (value === false) {
      setSensorsData([]);
      setReportData(null);
      setLoadingReports(false);
      setVehicleSelected("");
      setInputValueSwitch("farms");
      setInputValueLabel("Granjas");
      sessionStorage.setItem("valueKanbanLabel", "Granjas");
      sessionStorage.setItem("valueKanban", "farms");
    } else if (value === true) {
      setSensorsData([]);
      setReportData(null);
      setLoadingReports(false);
      setVehicleSelected("");
      setInputValueSwitch("vehicles");
      setInputValueLabel("Veículos");
      sessionStorage.setItem("valueKanbanLabel", "Veículos");
      sessionStorage.setItem("valueKanban", "vehicles");
    }
  };

  return (
    <>
      {inputValueSwitch === "vehicles" ? (
        <AppLayout>
          <Box
            component="form"
            noValidate
          >
            <Grid container>
              <Grid item xl={3}>
                <FormControl>
                  <Autocomplete
                    disablePortal
                    options={vehicles}
                    onChange={(e, newValue) => {
                      setVehicleSelected(newValue.label);
                      if (reportData && vehicleSelected !== newValue.label) {
                        setReportData(null);
                      }
                    }}
                    value={vehicleSelected}
                    sx={{ width: 260, padding: "10px" }}
                    size="small"
                    renderInput={(params) => (
                      <TextField {...params} label="Veículo" />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xl={6}>
                <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Data de Início"
                      onOpen={() => {
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      onChange={(e) => {
                        handleChangeInitialDate(e.$d);
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      value={initialDate}
                      size="small"
                      inputFormat="DD/MM/YYYY HH:mm:ss"
                      renderInput={(params) => (
                        <TextField
                          sx={{ width: 260, padding: "10px" }}
                          size="small"
                          {...params}
                        />
                      )}
                      minDate={
                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                      }
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Data de Término"
                      onOpen={() => {
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      onChange={(e) => {
                        handleChangeFinalDate(e.$d);
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      value={finalDate}
                      size="small"
                      inputFormat="DD/MM/YYYY HH:mm:ss"
                      renderInput={(params) => (
                        <TextField
                          sx={{ width: 260, padding: "10px" }}
                          size="small"
                          {...params}
                        />
                      )}
                      minDate={
                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                      }
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xl={3}>
                <FormControl style={{ float: "right", marginTop: "10px" }}>
                  <Button
                    disabled={vehicleSelected === "" ? true : false}
                    style={{ background: "#008000", color: "white", boxShadow: "1px 1px 5px 1px rgba(165, 165, 165, 0.82)" }}
                    onClick={handleReportsGenerate}
                  >
                    Gerar Relatório
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xl={2} md={3} sm={4} xs={4}>
              <FormControlLabel
                control={
                  <Stack direction="row" sx={{ alignItems: 'center', marginLeft: '20px' }}>
                    <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                    <Switch
                      sx={{
                        height: "45px",
                        width: "70px",
                        "& .MuiSwitch-switchBase": {
                          margin: 0,
                          padding: 1,
                          transform: "translateX(2px)",
                          "&.Mui-checked": {
                            color: "#fff",
                            transform: "translateX(30px)",
                            "& .MuiSwitch-thumb:before": {},
                            "& + .MuiSwitch-track": {
                              opacity: 1,
                              backgroundColor: "#5c7fb8",
                            },
                          },
                        },
                        "& .MuiSwitch-thumb": {
                          backgroundColor: "#21519f",
                          width: 28,
                          height: 28,
                          "&:before": {
                            content: "''",
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            left: 1,
                            top: 0,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                          },
                        },
                        "& .MuiSwitch-track": {
                          opacity: 1,
                          backgroundColor: "#5c7fb8",
                          borderRadius: 20 / 2,
                        },
                      }}
                      checked={true}
                      onChange={handleChangeSwitch}
                    />
                    <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                  </Stack>
                }
              />
            </Grid>
          </Box>

          <Box className={styles.reportContent}>
            {!loadingReportsSkeleton && reportData ? (
              <Grid item container xs={12} md={12} xl={12}>
                <Card className={styles.reportCard}>
                  <CardContent>
                    <Typography sx={{ fontSize: 18 }} color="text.primary">
                      Data Início:{" "}
                      {moment(initialDate).format("DD/MM/YYYY HH:mm:ss")} <br />
                      Data Final:{" "}
                      {moment(finalDate).format("DD/MM/YYYY HH:mm:ss")}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginTop: "20px",
                          marginBottom: "50px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={(e) =>
                            ExportExcel(
                              reportData,
                              getSensorDataTemp(sensorsData),
                              getSensorData(sensorsData, "humidity"),
                              getSensorData(sensorsData, "co2"),
                              getSensorData(sensorsData, "vibration"),
                              getSensorData(sensorsData, "PowerTension"),
                              getSensorData(sensorsData, "Odometer"),
                              moment(initialDate).format("DD/MM/YYYY HH:mm:ss"),
                              moment(finalDate).format("DD/MM/YYYY HH:mm:ss")
                            )
                          }
                          style={{
                            background: "#008000",
                            color: "white",
                            marginRight: '20px'
                          }}
                          endIcon={<FileExcelTwoTone twoToneColor="rgb(56, 209, 0)" />}
                        >
                          Exportar dados para Planilha
                        </Button>
                        <Button
                          onClick={(e) =>
                            MakePDF(
                              reportData,
                              getSensorDataTemp(sensorsData),
                              getSensorData(sensorsData, "humidity"),
                              getSensorData(sensorsData, "co2"),
                              getSensorData(sensorsData, "vibration"),
                              getSensorData(sensorsData, "Odometer"),
                              moment(initialDate).format("DD/MM/YYYY HH:mm:ss"),
                              moment(finalDate).format("DD/MM/YYYY HH:mm:ss"),
                              companyName
                            )
                          }
                          style={{ background: "#008000", color: "white" }}
                          endIcon={<FilePdfTwoTone twoToneColor="rgb(255, 0, 0)" />}
                        >
                          Download PDF
                        </Button>
                      </div>
                    </Typography>
                  </CardContent>
                </Card>
                <Grid item xs={12} md={12} xl={12}>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "black",
                        }}
                        color="text.secondary"
                        gutterBottom
                      >
                        Temperatura Interna / Externa
                      </Typography>
                      <div className={styles.chartContainer}>
                        <LineChartReport
                          sensor={"temperature"}
                          dataToChart={getSensorDataTemp(sensorsData)}
                          alarms={alarms}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "black",
                        }}
                        color="text.secondary"
                        gutterBottom
                      >
                        Umidade (%)
                      </Typography>
                      <div className={styles.chartContainer}>
                        <LineChartReport
                          sensor={"humidity"}
                          dataToChart={getSensorData(sensorsData, "humidity")}
                          alarms={alarms}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "black",
                        }}
                        color="text.secondary"
                        gutterBottom
                      >
                        CO2 (PPM)
                      </Typography>
                      <div className={styles.chartContainer}>
                        <LineChartReport
                          sensor={"co2"}
                          dataToChart={getSensorData(sensorsData, "co2")}
                          alarms={alarms}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: 14,
                          fontWeight: "bold",
                          color: "black",
                        }}
                        color="text.secondary"
                        gutterBottom
                      >
                        Vibração (g)
                      </Typography>
                      <div className={styles.chartContainer}>
                        <LineChartReport
                          sensor={"mechnical-vibrations"}
                          dataToChart={getSensorData(sensorsData, "vibration")}
                          alarms={alarms}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Grid container justifyContent="space-between">
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "black",
                          }}
                          color="text.secondary"
                          gutterBottom
                        >
                          km/h
                        </Typography>
                      </Grid>
                      <div className={styles.chartContainer2}>
                        <LineChartReport
                          sensor={"ThermoKing"}
                          dataToChart={getSensorData(sensorsData, "ThermoKing")}
                        />
                      </div>
                    </CardContent>
                  </Card>
                  <Card className={styles.reportCardChart}>
                    <CardContent>
                      <Grid container justifyContent="space-between">
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "black",
                          }}
                          color="text.secondary"
                          gutterBottom
                        >
                          Tensão da Bateria (V)
                        </Typography>
                      </Grid>
                      <div className={styles.chartContainer2}>
                        <LineChartReport
                          sensor={"PowerTension"}
                          dataToChart={getSensorData(sensorsData, "PowerTension")}
                          powerTensionNominal={powerTensionNominal}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item md={12} xl={12}>
                  <Card className={styles.reportCardPositions}>
                    <CardContent>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "black",
                          }}
                          color="text.secondary"
                          gutterBottom
                        >
                          Alarmes
                        </Typography>
                      </div>
                      <Box sx={{ height: 400, width: "100%", padding: "14px" }}>
                        <DataGrid
                          rows={alarms}
                          columns={columns}
                          pageSize={5}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          experimentalFeatures={{ newEditingApi: true }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>
            ) : (loadingReportsSkeleton && reportData != null) ||
              (loadingReportsSkeleton && reportData === null) ? (
              <Grid item container xs={12} md={12} xl={12}>

                <CustomSkeleton width={"85vw"} height={"150px"}>
                </CustomSkeleton>
                <Grid item xs={12} md={12} xl={12}>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-50px"}>
                  </CustomSkeleton>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-70px"}>
                  </CustomSkeleton>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-70px"}>
                  </CustomSkeleton>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-70px"}>
                  </CustomSkeleton>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-70px"}>
                  </CustomSkeleton>

                  <CustomSkeleton width={"85vw"} height={"350px"} marginTop={"-70px"}>
                  </CustomSkeleton>

                </Grid>

                <Grid item xs={12} md={12} xl={12}>
                  <CustomSkeleton width={"85vw"} height={"500px"} marginTop={"-70px"}>
                  </CustomSkeleton>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
          </Box>
        </AppLayout>
      ) : (

        <AppLayout>
          <Box
            component="form"
            noValidate
          >
            <Grid container>
              <Grid item xl={3}>
                <FormControl>
                  <Autocomplete
                    disablePortal
                    options={farms}
                    onChange={(e, newValue) => {
                      setVehicleSelected(newValue.label);
                      if (reportData && vehicleSelected !== newValue.label) {
                        setReportData(null);
                      }
                    }}
                    value={vehicleSelected}
                    sx={{ width: 260, padding: "10px" }}
                    size="small"
                    renderInput={(params) => (
                      <TextField {...params} label="Granjas" />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xl={6}>
                <FormControl style={{ display: 'flex', flexDirection: 'row' }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Data de Início"
                      onOpen={() => {
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      onChange={(e) => {
                        handleChangeInitialDate(e.$d);
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      value={initialDate}
                      size="small"
                      inputFormat="DD/MM/YYYY HH:mm:ss"
                      renderInput={(params) => (
                        <TextField
                          sx={{ width: 260, padding: "10px" }}
                          size="small"
                          {...params}
                        />
                      )}
                      minDate={
                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                      }
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Data de Término"
                      onOpen={() => {
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      onChange={(e) => {
                        handleChangeFinalDate(e.$d);
                        if (reportData) {
                          setReportData(null);
                        }
                      }}
                      value={finalDate}
                      size="small"
                      inputFormat="DD/MM/YYYY HH:mm:ss"
                      renderInput={(params) => (
                        <TextField
                          sx={{ width: 260, padding: "10px" }}
                          size="small"
                          {...params}
                        />
                      )}
                      minDate={
                        new Date(date.getFullYear(), date.getMonth() - 3, 1)
                      }
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xl={3}>
                <FormControl style={{ float: "right", marginTop: "10px" }}>
                  <Button
                    disabled={vehicleSelected === "" ? true : false}
                    style={{ background: "#008000", color: "white", boxShadow: "1px 1px 5px 1px rgba(165, 165, 165, 0.82)" }}
                    onClick={handleReportsGenerate}
                  >
                    Gerar Relatório
                  </Button>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xl={2} md={3} sm={4} xs={6}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Stack direction="row" sx={{ alignItems: 'center', marginLeft: '20px' }}>
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Granjas</Typography>
                      <Switch
                        sx={{
                          height: "45px",
                          width: "70px",
                          "& .MuiSwitch-switchBase": {
                            margin: 0,
                            padding: 1,
                            transform: "translateX(2px)",
                            "&.Mui-checked": {
                              color: "#fff",
                              transform: "translateX(30px)",
                              "& .MuiSwitch-thumb:before": {},
                              "& + .MuiSwitch-track": {
                                opacity: 1,
                                backgroundColor: "#5c7fb8",
                              },
                            },
                          },
                          "& .MuiSwitch-thumb": {
                            backgroundColor: "#21519f",
                            width: 28,
                            height: 28,
                            "&:before": {
                              content: "''",
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              left: 1,
                              top: 0,
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            },
                          },
                          "& .MuiSwitch-track": {
                            opacity: 1,
                            backgroundColor: "#5c7fb8",
                            borderRadius: 20 / 2,
                          },
                        }}
                        onChange={handleChangeSwitch}
                      />
                      <Typography variant={'subtitle2'} color={'rgb(62, 62, 62)'} fontWeight={500}>Veículos</Typography>
                    </Stack>
                  }
                />
              </FormGroup>
            </Grid>
          </Box>

          <Box className={styles.reportContent}>
            {!loadingReports && reportData ? (
              <Grid item container xs={12} md={12} xl={12}>
                <Card className={styles.reportCard}>
                  <CardContent>
                    <Typography sx={{ fontSize: 18 }} color="text.primary">
                      Data Início:{" "}
                      {moment(initialDate).format("DD/MM/YYYY HH:mm:ss")} <br />
                      Data Final:{" "}
                      {moment(finalDate).format("DD/MM/YYYY HH:mm:ss")}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          marginTop: "20px",
                          marginBottom: "50px",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={(e) =>
                            ExportExcelFarm(
                              reportData,
                              getSensorDataTempFarm(sensorsData),
                              getSensorDataFarm(sensorsData, "humidity"),
                              getSensorDataFarm(sensorsData, "co2"),
                              getSensorDataFarm(sensorsData, "portAndAc"),
                              getSensorData(sensorsData, "PowerTension"),
                              moment(initialDate).format("DD/MM/YYYY HH:mm:ss"),
                              moment(finalDate).format("DD/MM/YYYY HH:mm:ss")
                            )
                          }
                          style={{ background: "#008000", color: "white", marginRight: '20px' }}
                          endIcon={<FileExcelTwoTone twoToneColor="rgb(56, 209, 0)" />}
                        >
                          Exportar dados para Planilha
                        </Button>
                        <Button
                          onClick={(e) =>
                            MakeFarmsPDF(
                              reportData,
                              getSensorDataTempFarm(sensorsData),
                              getSensorDataFarm(sensorsData, "humidity"),
                              getSensorDataFarm(sensorsData, "co2"),
                              getSensorDataFarm(sensorsData, "portAndAc"),
                              moment(initialDate).format("DD/MM/YYYY HH:mm:ss"),
                              moment(finalDate).format("DD/MM/YYYY HH:mm:ss"),
                              companyName
                            )
                          }
                          style={{ background: "#008000", color: "white" }}
                          endIcon={<FilePdfTwoTone twoToneColor="rgb(255, 0, 0)" />}
                        >
                          Download PDF
                        </Button>
                      </div>
                    </Typography>
                  </CardContent>
                </Card>
                <Grid item xs={12} md={12} xl={12}>
                  <Card className={styles.reportCardChart2}>
                    <CardContent>
                      <div className={styles.divCardChart}>
                        <LineChartCardReport
                          dataToChart={getSensorDataTempFarm(sensorsData)}
                          type={"all"}
                          sensorName={"temperatureFarm"}
                        />
                      </div>
                    </CardContent>
                  </Card>

                  <Card className={styles.reportCardChart2}>
                    <CardContent>
                      <div className={styles.divCardChart}>
                        <LineChartCardReport
                          dataToChart={getSensorDataFarm(
                            sensorsData,
                            "humidity"
                          )}
                          type={"all"}
                          sensorName={"humidityFarm"}
                        />
                      </div>
                    </CardContent>
                  </Card>

                  <Card className={styles.reportCardChart2}>
                    <CardContent>
                      <div className={styles.divCardChart}>
                        <LineChartCardReport
                          dataToChart={getSensorDataFarm(sensorsData, "co2")}
                          type={"all"}
                          sensorName={"co2Farm"}
                        />
                      </div>
                    </CardContent>
                  </Card>

                  <Card className={styles.reportCardChartPortAndAC}>
                    <CardContent>
                      <div className={styles.divCardChart2}>
                        <LineChartCardReport
                          dataToChart={getSensorDataFarm(
                            sensorsData,
                            "portAndAc"
                          )}
                          type={"portAndAC"}
                          sensorName={"portAndAcFarm"}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} md={12} xl={12}>
                  <Card className={styles.reportCardPositions}>
                    <CardContent>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: "bold",
                            color: "black",
                          }}
                          color="text.secondary"
                          gutterBottom
                        >
                          Alarmes
                        </Typography>
                      </div>
                      <Box sx={{ height: 400, width: "100%", padding: "14px" }}>
                        <DataGrid
                          rows={alarms}
                          columns={columns}
                          pageSize={5}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          experimentalFeatures={{ newEditingApi: true }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
          </Box>
        </AppLayout>
      )}
    </>
  );
};
